/**
 * Advisors Single Map script
 */
class FinHub_AdvisorsSingleMap {
  constructor() {
    this.initState();
  }

  initState() {
    this.advisorPage = $('.advisor-single');
    this.advisorMapSection = this.advisorPage.find('.advisor-map');
    this.map = this.advisorMapSection.find('.map');
    this.mapOverlayBtn = this.advisorMapSection.find('.map-overlay-button');
    this.mapWrapper = this.advisorMapSection.find('#advisor-map-wrapper');
    this.lat = parseFloat(this.mapWrapper.attr('data-lat'));
    this.lng = parseFloat(this.mapWrapper.attr('data-lng'));

    if (this.mapOverlayBtn.length) {
      this.initEvents();
      this.initGlobalCallback();
    }
  }

  initEvents() {
    this.mapOverlayBtn.on('click', e => {
      e.preventDefault();
      let script = document.createElement('script');
      script.setAttribute('src', this.mapOverlayBtn.attr('data-maps-src'));
      $(script).appendTo(document.body);
    });
  }

  initGlobalCallback () {
    window.initAdviserMap = () => {
      this.map.addClass('is-active');

      const markerPosition = { 
        lat: this.lat, 
        lng: this.lng
      };

      let map = new google.maps.Map(document.getElementById('advisor-map-wrapper'), {
        zoom: 10,
        center: markerPosition,
      });

      new google.maps.Marker({
        position: markerPosition,
        map: map,
      });
    };
  }
}